/* eslint no-magic-numbers: 0 */

export enum Appnexus {
  id = 'appnexus',
  aliasId = 'appnexusAst',
  testPlacementId = '10534988'
}

export enum EmxDigital {
  id = 'emx_digital',
  desktopAutoplayId = '25926',
  desktopCtpId = '25927',
  mobileAutoplayId = '25929',
  mobileCtpId = '25928',
  testPlacementId = '25251'
}

export enum IndexExchangeVideo {
  bidAdjustment = 0.7,
  id = 'ixVideo',
  siteIdAutoplayDesktop = 341818,
  siteIdAutoplayMobile = 341820,
  siteIdCTPDesktop = 341819,
  siteIdCTPMobile = 341821,
  testSiteId = 199990,
  timeout = 1000
}

export enum OneVideo {
  id = 'oneVideo',
  publisherId = 'Mediavine',
  testPage = 'http://thehollywoodgossip.com',
  testPublisherId = 'HBexchange',
  testReferrer = 'http://thehollywoodgossip.com',
  testSiteId = 1
}

export enum OpenX {
  adhesionUnitId = '539690006',
  desktopAutoplayUnitId = '539918573',
  desktopCTPUnitId = '539690005',
  id = 'openx',
  mobileUnitId = '539690007'
}

export enum Pubmatic {
  adSlotAdhesion = 'adhesion_video',
  adSlotDesktop = 'desktop_video',
  adSlotMobile = 'mobile_video',
  adSlotSticky = 'sticky_video',
  id = 'pubmatic',
  publisherId = '157108',
  testAdSlot = 'test_video',
  testPublisherId = '157593'
}

export enum Rubicon {
  accountId = '17404',
  categoryLength = 40,
  id = 'rubicon',
  siteId = '169104',
  sizeId = '201',
  testAccountId = '7780',
  testSizeId = '87184',
  testZone = '412394',
  zoneDesktopAutoplay = '890898',
  zoneDesktopCTP = '815304',
  zoneMobileAutoplay = '891514',
  zoneMobileCTP = '891512'
}

export enum BidderSequence {
  fixed = 'fixed',
  random = 'random'
}
